import { IWSysHub, IWSysHubEvent } from '@coimbra-its/websys-ux-core'

import { useRef, useState } from 'react'
import { createSIWEConfig, formatMessage, SIWECreateMessageArgs, SIWESession, SIWEVerifyMessageArgs } from '@reown/appkit-siwe'
import { createAppKit } from '@reown/appkit'

import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { useSunStore } from '../store/sunSlice'

//export const projectId = '63242127221a9365f9f87e48d552536d' // Péter
export const projectId = 'ec2399d45d6d12326a12a50a09384a5b' // Kristóf


export const mainnet = {
	id: 56,
	name: 'Binance Smart Chain',
	network: 'bsc',
	nativeCurrency: {
		name: 'Binance Coin',
		symbol: 'BNB',
		decimals: 18,
	},
	rpcUrls: {
		default: {
			http: ['https://bsc-dataseed.binance.org'],
		},
		public: {
			http: ['https://bsc-dataseed1.defibit.io'],
		},
	},
	blockExplorers: {
		default: { name: 'BscScan', url: 'https://bscscan.com' },
	},
};

// 3. Create a metadata object
const metadata = {
	name: 'sunmoney-walletconect',
	description: 'Sunmoney Walletconnect',
	url: 'https://token.sdbn3.com', // origin must match your domain & subdomain
	icons: ['https://token.sdbn3.com/android-chrome-192x192.png']
}

async function getMessageParams() {
	return {
		domain: window.location.host,
		uri: window.location.origin,
		chains: [mainnet.id],
		statement: 'Please sign with your account'
	}
}

// ==========================================================================================================
// ---------------------------------------------- SIWE ------------------------------------------------------
// ==========================================================================================================

// (sign in with ethers) https://docs.walletconnect.com/web3modal/react/siwe

/*	az aláírás valamiért így megy:
	- getSession
	- getNonce
	- signOut (?????)
	- createMessage
	- verifyMessage()


*/


export function useCreateWeb3Modal(hub: IWSysHub) {
	const [modalCreated, setModalCreated] = useState(false);

	if (modalCreated)
		return;
	setModalCreated(true);

	/*
	const api = useSdbnApi();
	const siweGetNoncePost = api.siweGetNoncePost.useAction();
	const siweGetSessionPost = api.siweGetSessionPost.useAction();
	const siweVerifyMessagePost = api.siweVerifyMessagePost.useAction();
	const siweSignOutPost = api.siweSignOutPost.useAction();
	const setUser = useSunStore(state => state.setUser);

	const ignoreSignOut = useRef(false); // Valamiért meghívja token aláírás előtt feleslegesnek tűnő módon


	// ----------------- from here run once ----------------

	const siweConfig = createSIWEConfig({
		// ----- ez a verziót ajánlja a dokumentáció:  https://docs.walletconnect.com/appkit/vue/core/siwe
		getMessageParams,
		createMessage: ({ address, ...args }: SIWECreateMessageArgs) => {
			console.log('%c****************************** createMessage ****************************', 'color:red;', address, args);
			ignoreSignOut.current = false;
			let msg = formatMessage(args, address);
			// TODO:  valmiért undefined-ként adta vissza az "Issued At"-et, pedig a példák szerint (is) kell
			msg = msg.replace('Issued At: undefined', `Issued At: ${new Date().toISOString()}`);
			console.log('-------  formatMessage ----------', msg);
			return msg;
		},
		getNonce: async (address?: string) => {
			console.log('%c****************************** getNonce ****************************', 'color:red;', address);
			if (!address)
				throw new Error('No address');

			const loadingEvent: IWSysHubEvent = { severity: 'loading', message: 'Loading...' };
			hub.addEvent(loadingEvent);
			try {
				const res = await siweGetNoncePost({ walletAddress: address });
				if (!res.nonce)
					throw new Error('No nonce!');
				window.localStorage.setItem('sdbn1_wallet', address);
				window.localStorage.setItem('sdbn1_nonce', res.nonce);
				window.localStorage.setItem('sdbn1_nonce_is_signed', '0');
				if (!res.nonce)
					throw new Error(`No nonce in startup`);
				ignoreSignOut.current = true;
				return res.nonce;
			} catch (ex) {
				console.error(ex);
				throw ex;
			} finally {
				hub.removeEvent(loadingEvent);
			};

		},
		getSession: async () => {
			console.log('%c****************************** getSession ****************************', 'color:red;');
			//TODO: Itt kéne aszinkron ellenőrizni, hogy él-e session szerver oldalon?
			const sess_address = window.localStorage.getItem('sdbn1_wallet');
			const sess_nonce = window.localStorage.getItem('sdbn1_nonce');
			const sess_sdbn1_nonce_is_signed = window.localStorage.getItem('sdbn1_nonce_is_signed') === '1';
			if (sess_address && sess_nonce && sess_sdbn1_nonce_is_signed) {
				const resp = await siweGetSessionPost({ walletAddress: sess_address, nonce: sess_nonce })
				if (resp.user) {
					setUser(resp.user);
					const sess: SIWESession = {
						address: sess_address,
						chainId: mainnet.id, //TODO!!
					}
					return sess;
				} else {
					return null;
				}
			} else {
				return null;
			}
		},
		verifyMessage: async (args: SIWEVerifyMessageArgs) => {
			console.log('%c****************************** verifyMessage ****************************', 'color:red;', args);

			const sess_address = window.localStorage.getItem('sdbn1_wallet');
			const sess_nonce = window.localStorage.getItem('sdbn1_nonce');
			console.log(sess_address, sess_nonce);
			const loadingEvent: IWSysHubEvent = { severity: 'loading', message: 'Loading...' };
			hub.addEvent(loadingEvent);
			try {
				const res = await siweVerifyMessagePost({
					walletAddress: sess_address || '',
					nonce: sess_nonce || '',
					nonceSigned: args.signature,
					message: args.message,
				});
				setUser(res.user);
				console.log('---- verifyMessage vége....', res);
				window.localStorage.setItem('sdbn1_nonce_is_signed', '1');

				return true;

			} finally {
				hub.removeEvent(loadingEvent);
			}

		},
		signOut: async (...args) => {
			console.log('%c****************************** signOut ****************************', 'color:red;', ignoreSignOut, args);
			if (ignoreSignOut.current)
				return false;
			const sess_address = window.localStorage.getItem('sdbn1_wallet');
			const sess_nonce = window.localStorage.getItem('sdbn1_nonce');
			const loadingEvent: IWSysHubEvent = { severity: 'loading', message: 'Loading...' };
			hub.addEvent(loadingEvent);
			try {
				await siweSignOutPost({
					walletAddress: sess_address || '',
					nonce: sess_nonce || '',
				})
				window.localStorage.removeItem('sdbn1_wallet');
				window.localStorage.removeItem('sdbn1_nonce');
				window.localStorage.removeItem('sdbn1_nonce_is_signed');
				setUser(null);
				return true
			} finally {
				hub.removeEvent(loadingEvent);
			}
		},
	})
	*/
	// 5. Create a Web3Modal instance
	/*createWeb3Modal({
		ethersConfig,
		chains: [mainnet],
		projectId,
		enableAnalytics: false, // Optional - defaults to your Cloud configuration
		siweConfig,
	})*/
	console.log('---->createAppKit');
	const appKit = createAppKit({
		adapters: [new EthersAdapter()],
		networks: [mainnet],
		metadata,
		projectId,
		features: {
			analytics: true,
		},
		//siweConfig,
	});


}

/*export const sale_address = "0x3eb4237E402d5954d6cE106C045c1aB473BCC39f";
export const usdt_address = "0x55d398326f99059fF775485246999027B3197955";
export const token_address = "0xEED7Cc0ea13987509d727577e634f6722333bbDF";
export const payout_address_sdbn2 = "0x654443Ebb62dBab200aa90db749A0af74F3923D0";
export const payout_address_sdbn2plus = "0x62F915d3bCE0119862d3d68C1649341b930c1719";
export const token_address_sdbn2plus = "0x94FB41C94ac603eDEcDd210cf77CF2FFC979EC91";*/

export const sale_address = "0xEDeD5EAf2E98B0B1c478956300a83e2004BD45A7";
export const usdt_address = "0x55d398326f99059fF775485246999027B3197955";
export const token_address = "0x96E2f167180768418E2D80EBa8213457f9985A3C";
//export const payout_address_sdbn3 = "0xf514f5634a2eC381A3E5c9727ABc12f7E47e9048";
export const payout_address_sdbn3 = "0x5A53F97962AA221351A46B4BC8Ae823b3D5AEF34";
export const payout_address_sdbn3plus = "0x5A53F97962AA221351A46B4BC8Ae823b3D5AEF34"; // TODOOOOO!!!!!
export const token_address_sdbn3plus = "0x3503C50B11bCBdD0dBD3bFd40648715BBE14aB12";

export const PAYOUT_IGNORE_ACCOUNTS = [sale_address];

export const ADMINS: string[] = [
	'0xDE33d58193Cdec2a6383649353A2bFbFB037c4ed',	//kri
	'0xCc5DD85E2B0D034D204648045dD493be86102365', //Teng
	'0xb9193f8b6a3692a9fc64caf602904d631a3f32d7', //Péter SDNB3
	'0x767771f79eb2D439ae7832a705485218E4b9cF95', //Péter SDNB3
];


